import React from "react";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";

/* Page Wrapper */

const PolicySection = styled.section`
  padding: 120px 20px 80px;
  background: #ffffff;
`;

/* Content Wrapper */

const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
`;

/* Title */

const Title = styled.h1`
  font-size: 36px;
  margin-bottom: 20px;
`;

/* Section Title */

const SubTitle = styled.h2`
  font-size: 22px;
  margin-top: 35px;
  margin-bottom: 10px;
`;

/* Paragraph */

const Text = styled.p`
  line-height: 1.7;
  margin-bottom: 12px;
  color: #555;
`;

/* List */

const List = styled.ul`
  margin-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
`;

const CancellationReturnPolicy = () => {
  return (
    <>
      <TopNavbar />

      <PolicySection>
        <Wrapper>

          <Title>Cancellation & Return Policy</Title>

          <Text>
            At EBK Thangamaligai, we aim to provide high-quality jewellery
            and excellent customer service. If you are not satisfied with
            your purchase, we offer cancellation and return options
            according to the policies described below.
          </Text>

          <SubTitle>1. Order Cancellation</SubTitle>

          <Text>
            If you wish to cancel your order, you may do so before the
            product has been shipped. Once the order is cancelled, the
            entire order amount will be refunded to the original payment
            method.
          </Text>

          <Text>
            To request cancellation, customers must submit a cancellation
            request along with the reason for cancellation. EBK
            Thangamaligai reserves the right to review and approve the
            cancellation request based on valid reasons.
          </Text>

          <SubTitle>2. Return & Exchange Policy</SubTitle>

          <Text>
            If you are not completely satisfied with your purchase,
            EBK Thangamaligai will gladly assist you with a return
            or exchange according to the conditions listed below.
          </Text>

          <SubTitle>3. 30-Day Exchange & Money Back Policy</SubTitle>

          <Text>
            Customers may return eligible products within
            <strong> 30 days from the date of delivery </strong>
            for a refund or exchange based on the full invoice value.
          </Text>

          <Text>
            To initiate a return or exchange, customers must contact
            our support team and provide the invoice details along
            with the reason for the return.
          </Text>

          <SubTitle>4. Conditions for Returns</SubTitle>

          <Text>
            Products must meet the following conditions to be eligible
            for a return or exchange:
          </Text>

          <List>
            <ListItem>The product must be returned within 30 days of delivery.</ListItem>
            <ListItem>The product must be unused and in original condition.</ListItem>
            <ListItem>Original packaging and invoice must be included.</ListItem>
            <ListItem>The product must not show signs of damage or alteration.</ListItem>
          </List>

          <SubTitle>5. Non-Returnable Items</SubTitle>

          <Text>
            The following products are not eligible for return or exchange:
          </Text>

          <List>
            <ListItem>Customized or specially designed jewellery.</ListItem>
            <ListItem>Items altered or resized after purchase.</ListItem>
            <ListItem>Products damaged due to misuse.</ListItem>
          </List>

          <SubTitle>6. Contact Us</SubTitle>

          <Text>
            For cancellation, return, or exchange requests, please
            contact our customer support team.
          </Text>

          <Text>
            <strong>Email:</strong> support@ebkthangamaligai.com
          </Text>

        </Wrapper>
      </PolicySection>

      <Footer />
    </>
  );
};

export default CancellationReturnPolicy;